/**
 * Código prestador sector salud (FEV / RIPS).
 * Formato habitual: 12 caracteres (10 base + 2 de sede). En facturación se envían los primeros 10.
 */

export function normalizarCodigoPrestadorSalud(codigo) {
    const trimmed = String(codigo ?? '').trim();
    if (!trimmed) {
        return '';
    }
    return trimmed.slice(0, 10);
}

/**
 * IPS: siempre el código único de la clínica (mismo en todas las facturas).
 * No IPS: código de habilitación del profesional seleccionado.
 */
export function resolverCodigoPrestadorFactura(client, profesionalId, profesionales = []) {
    if (client && Number(client.presenta_rips_como_ips) === 1) {
        return normalizarCodigoPrestadorSalud(client.codigo_unico_ips);
    }

    const prof = profesionales.find((p) => String(p.id) === String(profesionalId));
    return normalizarCodigoPrestadorSalud(prof?.codigo_habilitacion);
}

export function esInstitucionIps(client) {
    return Boolean(client && Number(client.presenta_rips_como_ips) === 1);
}
